function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { PromiseUtils } from "./PromiseUtils.js";
/**
 * Helper class for managing pending promises.
 * DH-6167 When cancel is called, it calls cancel on ALL promises, including ones that have already resolved.
 * This behaviour may change when DH-9464 is implemented.
 */
class Pending {
  constructor() {
    _defineProperty(this, "pending", []);
    _defineProperty(this, "resolved", []);
  }
  /**
   * Begins tracking a promise. After the promise has resolved, it's removed from tracking.
   * @param item Item to track.
   * @param cleanup The cleanup function to use when the promise is cancelled
   * @returns CancelablePromise Returns a cancelable promise.
   */
  add(item, cleanup) {
    var promise = PromiseUtils.makeCancelable(item, cleanup);
    this.pending.push(promise);
    promise.then(() => {
      this.resolve(promise);
    }, () => {
      this.resolve(promise);
    });
    return promise;
  }

  /**
   * Remove a promise from tracking.
   * @param promise Promise to stop tracking
   */
  remove(promise) {
    for (var i = 0; i < this.pending.length; i += 1) {
      if (this.pending[i] === promise) {
        this.pending.splice(i, 1);
        return;
      }
    }
  }
  resolve(promise) {
    this.remove(promise);
    this.resolved.push(promise);
  }

  /**
   * Cancel all pending promises and remove them from tracking.
   */
  cancel() {
    var allPromises = [...this.pending, ...this.resolved];
    for (var i = 0; i < allPromises.length; i += 1) {
      allPromises[i].cancel();
    }
    this.pending = [];
    this.resolved = [];
  }
}
export default Pending;
//# sourceMappingURL=Pending.js.map